import { useMemo } from 'react';

import { useAppSelector } from '@store/store.tsx';
import {
  selectIsSuperuser,
  selectUserGroups,
  selectUserPermissions,
} from '@store/slices/userSlice.tsx';

const EXPORT_GROUPS = new Set(['erp:staff:admin', 'admin']);

const normalizeTokens = (values: readonly unknown[]): string[] =>
  values
    .map((value) => String(value ?? '').trim().toLowerCase())
    .filter(Boolean);

export const useCanExportData = (): boolean => {
  const isSuperuser = useAppSelector(selectIsSuperuser);
  const groups = useAppSelector(selectUserGroups);
  const permissions = useAppSelector(selectUserPermissions);

  return useMemo(() => {
    if (isSuperuser) {
      return true;
    }
    const tokens = [...normalizeTokens(groups), ...normalizeTokens(permissions)];
    return tokens.some((token) => EXPORT_GROUPS.has(token));
  }, [groups, isSuperuser, permissions]);
};
